/** Public explanations for known preflight failures. Do not expose internal
 * recovery instructions, saved IDs or provider errors in the transcript. */
const messages: Record<string, string> = {
  CAMPAIGN_PACKAGE_STATIC_ONLY:
    'These saved creatives could not use combined approval. Prepare a launch approval for each existing ad.',
  CAMPAIGN_PACKAGE_MEDIA_PENDING:
    'The requested ad creatives are still rendering. No approval card is ready yet.',
  CAMPAIGN_PACKAGE_MEDIA_FAILED:
    'A requested ad creative failed to render. Repair it before preparing launch approval.',
  CAMPAIGN_PACKAGE_OFFERS_DIFFER:
    'The requested ads use different promotions. Review their saved promotions before preparing combined launch approval.',
  CAMPAIGN_PACKAGE_OFFER_MISMATCH:
    'The selected promotion does not match the saved ad creatives. Select their matching saved promotion before preparing launch approval.',
  CAMPAIGN_PACKAGE_OFFER_MISSING:
    'The requested promotion is not linked to the saved ad creatives. Review their promotion links before preparing launch approval.',
  CAMPAIGN_PACKAGE_DESTINATION_REQUIRED:
    // Shown before Claire asks for the website: on a lead-form ad that link is
    // a Meta requirement, not where a tap goes, so never call it the destination.
    'Meta needs a website link saved on an ad before launch approval can be prepared.',
  CAMPAIGN_PACKAGE_DESTINATION_INVALID:
    'An ad has an invalid destination. Correct it before preparing launch approval.',
  CAMPAIGN_PACKAGE_COPY_REPAIR_REQUIRED:
    'Saved ad copy needs correction before launch approval can be prepared.',
  CAMPAIGN_PACKAGE_CREATIVE_COPY_REPAIR_REQUIRED:
    'Text in a saved creative needs correction before launch approval can be prepared.',
  CAMPAIGN_PACKAGE_BUDGET_BLOCKED:
    'The earlier budget change has not been verified. Verify it before preparing launch approval.',
  CAMPAIGN_PACKAGE_APPROVAL_STALE:
    'The saved campaign changed after approval. Review the current campaign before launching.',
};

export function packageLaunchErrorMessage(code: unknown): string {
  return (
    (typeof code === 'string' && Object.hasOwn(messages, code)
      ? messages[code]
      : undefined) ??
    'The campaign package could not be completed. No approval card is ready yet.'
  );
}
